module.exports = __webpack_public_path__ + "img/loading.gif";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/img/loading.gif
// module id = 532
// module chunks = 68 69